// Copyright (c) 2016 Deere & Company

import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import t from 'tcomb';

const ClaimRecordInfo = t.struct({
    createdBy: TimestampUser,
    createdDate: t.maybe(t.Number),
    updatedBy: TimestampUser,
    updatedDate: t.maybe(t.Number)
}, {
    name: 'ClaimRecordInfo',
    strict: true
});

export const getDefaultState = () => new ClaimRecordInfo({
    createdBy: getTimestampUserDefaultState(),
    createdDate: null,
    updatedBy: getTimestampUserDefaultState(),
    updatedDate: null
});

export default ClaimRecordInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-record-info.js